import type { UUID } from 'crypto';
import { classNames } from 'primereact/utils';
import { ChangeEvent, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { useCreateOrUpdateProfileServiceMutation, useDeleteProfileMutation, useGetProfileMutation } from '../../../api/AdminProfileAPI';
import { useGetAuftraggeberListeMutation } from '../../../api/OfficeAPI';
import { useGetRollenMutation } from '../../../api/StammdatenAPI';
import { IAuftraggeber, IProfileDto } from '../../../types/Types';
import { formatToStringISODate } from '../../../util/DateUtils';
import LandingpageHeader from '../../header/LandingpageHeader';
import styles from '../admin.module.scss';

const emptyIProfileDto: IProfileDto = {
  uid: '',
  email: '',
  name: '',
  calendarId: '',
  is2fa: false,
  rollen: [],
  //auftraggeber: null,
  auftraggeberMultiple: [],
  activeUntil: undefined,
}

export default function ProfileDetail() {
  const { t } = useTranslation();

  const navigate = useNavigate();
  const location = useLocation();

  const [isLoaded, setLoaded] = useState<boolean>(false);
  const [daten, setDaten] = useState<IProfileDto>(emptyIProfileDto);

  const [getProfileAPI] = useGetProfileMutation();
  const [getRolesAPI] = useGetRollenMutation();
  const [deleteProfileAPI] = useDeleteProfileMutation();
  const [createOrUpdateProfileService] = useCreateOrUpdateProfileServiceMutation();
  const [getListeAuftraggeberAPI] = useGetAuftraggeberListeMutation();

  const [rolesNotInProfile, setRolesNotInProfile] = useState<string[]>([]);
  const [rolesInProfile, setRolesInProfile] = useState<string[]>([]);
  const [linksRolle, setLinksRolle] = useState<string>("");
  const [rechtsRolle, setRechtsRolle] = useState<string>("");

  const [auftraggeberNotInProfile, setAuftraggeberNotInProfile] = useState<string[]>([]);
  const [auftraggeberInProfile, setAuftraggeberInProfile] = useState<string[]>([]);
  const [linksAuftraggeber, setLinksAuftraggeber] = useState<string>("");
  const [rechtsAuftraggeber, setRechtsAuftraggeber] = useState<string>("");

  const [listeAuftraggeber, setListeAuftraggeber] = useState<IAuftraggeber[]>([]);

  const init = () => {


    //
    if (location.state.view === 'detail') {
      getProfileAPI(location.state.id)
        .unwrap()
        .then((e) => {
          setDaten(e);
          setLoaded(true);

          setAuftraggeberInProfile(e.auftraggeberMultiple ?? []);
          setRolesInProfile(e.rollen);

        })
        .catch((ee) => console.log(ee))

    } else if (location.state.view === 'create') {
      setDaten(emptyIProfileDto)
      setLoaded(true);
    }
  }

  const checkLeftProfiles = () => {
    getRolesAPI().unwrap()
      .then((e) => {
        setRolesNotInProfile(e.filter(role => !rolesInProfile.includes(role.name!)).map((role) => role.name));
      })
  }

  const checkLeftAuftraggeber = () => {
    // Auftraggeber
    getListeAuftraggeberAPI()
      .unwrap()
      .then((e) => {
        setListeAuftraggeber(e);
        setAuftraggeberNotInProfile(e.filter(auftraggeber => !auftraggeberInProfile.includes(auftraggeber.uid)).map((auftraggeber) => auftraggeber.uid));
      })
      .catch((ee) => console.log(ee))

  }

  const handleDelete = (e: { preventDefault: () => void; target: any; }) => {
    e.preventDefault();
    if (window.confirm('Sind sie sicher den Datensatz löschen zu wollen?')) {
      deleteProfileAPI(daten!.uid).unwrap()
        .then(() => navigate('/admin/profiles/'))
        .catch((ee) => console.log(ee))
    }
  }

  const handleSubmit = (e: { preventDefault: () => void; target: any; }) => {
    e.preventDefault();

    if (location.state.view === 'detail' || location.state.view === 'create') {

      if (location.state.view === 'detail') {

        createOrUpdateProfileService({
          uid: daten!.uid,
          email: daten.email,
          name: daten.name,
          calendarId: daten.calendarId,
          is2fa: daten.is2fa,
          rollen: rolesInProfile,
          //auftraggeber: daten.auftraggeber,
          auftraggeberMultiple: auftraggeberInProfile.length ? (auftraggeberInProfile as UUID[]) : [],
          activeUntil: daten.activeUntil,
          color_profile: daten.color_profile,
        })
          .then(() => navigate('/admin/profiles/'))
          .catch((ee) => console.log(ee))
      }

      if (location.state.view === 'create') {

        createOrUpdateProfileService({
          uid: daten!.uid,
          email: daten.email,
          name: daten.name,
          calendarId: daten.calendarId,
          is2fa: daten.is2fa,
          rollen: rolesInProfile,
          //auftraggeber: daten.auftraggeber,
          auftraggeberMultiple: auftraggeberInProfile.length ? (auftraggeberInProfile as UUID[]) : [],
          activeUntil: daten.activeUntil
        })
          .then(resp => {

            navigate('/admin/profiles/');

          })
          .catch((ee) => console.log(ee))
      }

    }
  }

  const changeit = (e: React.ChangeEvent<HTMLInputElement>) => {
    setDaten((prevData) => ({
      ...prevData,
      [e.target.name]: e.target.value
    }));
  }

  const changeitselect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setDaten((prevData) => ({
      ...prevData,
      [e.target.name]: e.target.value
    }));
  }

  const changedate = (e: ChangeEvent<HTMLInputElement>) => {
    setDaten((prevData) => ({
      ...prevData,
      [e.target.name]: e.target.value
    }));
  }

  useEffect(() => {
    checkLeftProfiles();
    checkLeftAuftraggeber();
  }, [rolesInProfile]);

  useEffect(() => {
    init();
  }, []);

  //<div><input type="text" className='wg-input-text' name="salutation" value={daten?.salutation} onChange={changeit} /></div><div></div>
  //<button className="wg-btn" onClick={() => navigate('', { state: { view: 'create' } })}><i className="pi pi-plus"></i><span style={{ marginLeft: "1em" }}>NEUES ANLEGEN</span></button>
  return (
    <>
      <div className={classNames(styles.centerContainer)}>

        <LandingpageHeader />

        <div className='container' >


          <button
            onClick={() => {
              navigate("../", {
                relative: "path"
              });
            }}

            style={{ marginBottom: "20px" }}
            className=' btn btn-outline-primary'
          ><i className="bi bi-arrow-left"></i> {t('deTranslation.auftragDetails.backButton')}
          </button>


          <div className={styles['wg-detail-ueb']}>
            <div><span style={{ fontSize: "28pt", fontWeight: "700" }}>Profile Detail</span></div>
            <div style={{ textAlign: "end" }}></div>
          </div>

          {(isLoaded && daten !== undefined &&
            <>
              <form onSubmit={handleSubmit} className={styles["wg-detail-form"]} >

                <div className={styles['wg-detail-form-ueb']}>
                  <div><span style={{ fontSize: "28pt", fontWeight: "700" }}>{daten?.uid}</span></div>
                  <div style={{ textAlign: "end" }}>{(location.state.view === 'detail' && <button type="button" className={styles["wg-a"]} onClick={handleDelete}><i className="bi bi-trash"></i></button>)}</div>
                </div>

                <div className={styles["wg-detail-grid-2"]}>
                  <div><label className={styles['wg']}>E-Mail-Adresse</label><input type="text" className={styles['wg-input-text']} name="email" value={daten?.email} onChange={changeit} /></div>
                  <div><label className={styles['wg']}>Name</label><input type="text" className={styles['wg-input-text']} name="name" value={daten?.name} onChange={changeit} /></div>
                  <div><label className={styles['wg']}>Calendar Id</label><input type="text" className={styles['wg-input-text']} name="calendarId" value={daten?.calendarId} onChange={changeit} /></div>
                  <div><label className={styles['wg']}>2 Faktor</label><select name="is2fa" className={styles['wg-input-select']} onChange={changeitselect} value={"" + daten.is2fa}>
                    <option value="false">Nein</option>
                    <option value="true">Ja</option>
                  </select></div>

                  {/*<div><label className={styles['wg']}>Auftraggeber</label><select name="auftraggeber" className={styles['wg-input-select']} onChange={changeitselect} value={"" + daten.auftraggeber}>
                    <option value={""}>-- Bitte auswählen --</option>
                    {listeAuftraggeber.map((auftraggeber) => <option key={auftraggeber.uid} value={auftraggeber.uid}>{auftraggeber.name}</option>)}
                  </select></div>*/}

                  <div><label className={styles['wg']}>Deaktiviert ab</label><input className={styles['wg-input-text']} type="date" name="activeUntil" value={formatToStringISODate(daten?.activeUntil)} onChange={changedate} /></div>
                  <div><label className={styles['wg']}>Farbe</label><div><input
                    id={"colorinput"}
                    type="color"
                    value={(daten.color_profile?.length === 7) ? daten.color_profile : "#" + daten.color_profile}
                    onChange={(e) => setDaten((prevData) => ({ ...prevData, color_profile: e.target.value }))}
                    className={styles['wg-input-text']}
                    style={{ width: "60px", padding: "0" }}
                  /></div></div>
                  <div></div>
                  <div></div>

                </div>


                <h4>Auftraggeber</h4>

                <p>Manager und Auftraggeber sollten nur einen Auftraggeber haben</p>
                
                <div style={{ display: "grid", gridTemplateColumns: "5fr 1fr 5fr", columnGap: "10px", marginBottom: "0px" }}>

                  <div>
                    <select style={{ width: "100%", border: "1px solid rgb(214, 211, 211)" }} size={5} onChange={(e) => { setLinksAuftraggeber(e.target.value); setRechtsAuftraggeber(""); }} >
                      {auftraggeberNotInProfile.map((auftraggeber) => <option key={auftraggeber} value={auftraggeber}>{listeAuftraggeber.find((a) => a.uid === auftraggeber)?.name || auftraggeber}</option>)}
                    </select>
                  </div>

                  <div>

                    <button className={((linksAuftraggeber === "") ? "btn btn-light" : " btn btn-primary")} disabled={linksAuftraggeber === ""} onClick={(e) => {
                      setAuftraggeberInProfile((prevdata) => [...prevdata, linksAuftraggeber]);
                      setAuftraggeberNotInProfile((prevdata) => prevdata.filter((auftraggeber) => auftraggeber !== linksAuftraggeber));
                      setLinksAuftraggeber("");
                    }} >Zuweisen</button>

                    <button className={((rechtsAuftraggeber === "") ? "btn btn-light" : " btn btn-primary")} disabled={rechtsAuftraggeber === ""} onClick={(e) => {
                      setAuftraggeberNotInProfile((prevdata) => [...prevdata, rechtsAuftraggeber]);
                      setAuftraggeberInProfile((prevdata) => prevdata.filter((auftraggeber) => auftraggeber !== rechtsAuftraggeber));
                      setRechtsAuftraggeber("");
                    }} >Entfernen</button>

                  </div>

                  <div>
                    <select style={{ width: "100%", border: "1px solid rgb(214, 211, 211)" }} size={5} onChange={(e) => { setRechtsAuftraggeber(e.target.value); setLinksAuftraggeber(""); }} >
                      {auftraggeberInProfile.map(function (auftraggeber) { return <option key={auftraggeber} value={auftraggeber}>{listeAuftraggeber.find((a) => a.uid === auftraggeber)?.name || auftraggeber}</option> })}
                    </select>
                  </div>

                </div>

                <h4>Rollen</h4>

                <div style={{ display: "grid", gridTemplateColumns: "5fr 1fr 5fr", columnGap: "10px", marginBottom: "20px" }}>

                  <div>
                    <select style={{ width: "100%", border: "1px solid rgb(214, 211, 211)" }} size={5} onChange={(e) => { setLinksRolle(e.target.value); setRechtsRolle(""); }} >
                      {rolesNotInProfile.map((role) => <option key={role} value={role}>{role}</option>)}
                    </select>
                  </div>

                  <div>

                    <button className={((linksRolle === "") ? "btn btn-light" : " btn btn-primary")} disabled={linksRolle === ""} onClick={(e) => {
                      setRolesInProfile((prevdata) => [...prevdata, linksRolle]);
                      setRolesNotInProfile((prevdata) => prevdata.filter((role) => role !== linksRolle));
                      setLinksRolle("");
                    }} >Zuweisen</button>

                    <button className={((rechtsRolle === "") ? "btn btn-light" : " btn btn-primary")} disabled={rechtsRolle === ""} onClick={(e) => {
                      setRolesNotInProfile((prevdata) => [...prevdata, rechtsRolle]);
                      setRolesInProfile((prevdata) => prevdata.filter((role) => role !== rechtsRolle));
                      setRechtsRolle("");
                    }} >Entfernen</button>

                  </div>

                  <div>
                    <select style={{ width: "100%", border: "1px solid rgb(214, 211, 211)" }} size={5} onChange={(e) => { setRechtsRolle(e.target.value); setLinksRolle(""); }} >
                      {rolesInProfile.map(function (role) { return <option key={role} value={role}>{role}</option> })}
                    </select>
                  </div>

                </div>

                <div style={{ textAlign: "end" }}><input type="submit" value="Speichern" className={styles['wg-btn']} /></div>

              </form>

            </>)}

        </div>
      </div >
    </>
  );
}